import axios from "axios";

export const callApiValidateSession = async () => {
  try {
    console.time("validate session");
    const response = await axios.get(`/api/validateSession`);
    console.timeEnd("validate session");
    return response.data;
  } catch (error) {
    throw error;
  }
};
